import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.LoginPage.LoginTwoFaModule', {
    title: 'Confirm login',
    codeBeenSent: 'Code has been successfully sent to your email.',
});
